module.exports = __webpack_public_path__ + "static/media/tdslogoWhite.8753dd47.png";